import { useQuery, gql } from '@apollo/client';

export const GET_DOCUMENTS_BY_IDS = gql`
  query getDocumentsByIds($documentsIds: [ObjectId!]!, $documentTemplateTitleSearch: String, $onlyAvailableForEmployee: Boolean) {
    getDocumentsByIds(
      documentsIds: $documentsIds
      documentTemplateTitleSearch: $documentTemplateTitleSearch
      onlyAvailableForEmployee: $onlyAvailableForEmployee
    ) {
      _id
      documentLabelId
      documentLabel {
        _id
        name
      }
      documentTemplatesIds
      documentTemplates {
        _id
        title
        description
        memberId
        createdAt
        file {
          location
          filename
        }
      }
    }
  }
`;

export const useGetDocumentsByIds = (
  documentsIds: string[],
  documentTemplateTitleSearch?: string,
  onlyAvailableForEmployee?: boolean
) => {
  const { data, loading } = useQuery(GET_DOCUMENTS_BY_IDS, {
    variables: { documentsIds, documentTemplateTitleSearch, onlyAvailableForEmployee },
    fetchPolicy: 'network-only',
  });

  return {
    documents: data?.getDocumentsByIds || [],
    loading,
  };
};
